<p-confirmDialog
  #logoutWarning
  appendTo="body"
  header="Warning"
  key="logout-warning"
  [autoZIndex]="true"
  [closable]="false"
  rejectButtonStyleClass="p-button-info"
  rejectLabel="Continue"
  acceptLabel="Logout"
>
  <ng-template pTemplate="message">
    <p>You are about to be logged out if you don't click Continue<br />
    Your session will expire automatically in {{ idleTimer | date:'mm:ss' }} minutes</p>
  </ng-template>
</p-confirmDialog>
